import React from "react";
import { MessageCircle } from "lucide-react";
import { useApp } from "../context/AppContext";

const WHATSAPP = "https://wa.me/213661413311?text=Bonjour%20Ssuq%2C%20je%20souhaite%20des%20informations%20sur%20vos%20produits%20en%20gros.";

const FloatingWhatsApp = () => {
  const { t } = useApp();
  return (
    <a
      href={WHATSAPP}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className="fixed z-[80] bottom-5 ltr:right-5 rtl:left-5 group flex items-center gap-0 bg-[#25D366] text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden"
    >
      <span className="flex items-center justify-center w-14 h-14 shrink-0">
        <MessageCircle size={26} />
      </span>
      <span className="max-w-0 group-hover:max-w-xs group-hover:ltr:pr-5 group-hover:rtl:pl-5 whitespace-nowrap font-display font-semibold text-sm transition-all duration-300">
        {t("whatsapp")}
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
